<template>
  <div class="home">
    <div class="hero-section">
      <div class="hero-background">
        <img src="@/assets/home/home.png" alt="ZZ游戏助手背景" class="background-image" />
      </div>
      <div class="hero-container">
        <!-- Left Content -->
        <div class="hero-content">
          <h1 class="main-title">ZZ游戏助手</h1>
          <h2 class="subtitle">赋能商业场景,驱动电竞生态升级</h2>
          <p class="description">
            面向网吧、电竞酒店等商业场景，我们深度整合腾讯、网易等头部游戏资源，以全链路运营管理工具与创新游戏生态服务，助力商户提升用户粘性、优化运营效率、实现营收增长。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.home {
  height: calc(100vh - 66px - 192px);
  position: relative;
  overflow: hidden;
}

.hero-section {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 40px;
  position: relative;
  z-index: 2;
  height: 100%;
  width: 100%;
  top: -20px;
}

.hero-content {
  flex: 1;
  max-width: 520px;
  z-index: 3;
}

.main-title {
  font-size: 42px;
  font-weight: 700;
  color: #1a365d;
  margin-bottom: 16px;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.subtitle {
  width: 420px;
  height: 41px;
  font-weight: 700;
  font-size: 28px;
  color: #1C2666;
  line-height: 41px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.description {
  margin-top: 24px;
  width: 600px;
  height: 78px;
  font-weight: 400;
  font-size: 18px;
  color: #1C2666;
  line-height: 26px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .hero-container {
    padding: 0 30px;
  }

  .main-title {
    font-size: 36px;
  }

  .subtitle {
    font-size: 18px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 600px;
  }

  .hero-container {
    text-align: center;
    padding: 40px 20px;
  }

  .hero-content {
    max-width: 100%;
  }

  .main-title {
    font-size: 32px;
  }

  .subtitle {
    font-size: 16px;
  }
}
</style>
